import { useEffect, useState } from 'react';
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { account } from '../../appwrite/config';

function Sidebar() {
    const { role } = useAuth();

    const location = useLocation();
    const navigate = useNavigate();
    const [isLoggedIn, setIsLoggedIn] = useState(null);

    useEffect(() => {
        document.documentElement.className = "";

        checkSession();
    }, []);

    const checkSession = async () => {
        try {
            const userData = await account.get();
            //setUser(userData);
            setIsLoggedIn(true);
        } catch {
            setIsLoggedIn(false);
            //navigate('/');
        }

        //JWT Token
        const token = sessionStorage.getItem('JWT_TOKEN');
        if (token === null) {
            setIsLoggedIn(false);
            logout();
        }
    };

    const logout = async () => {
        await account.deleteSession("current");
        //localStorage.removeItem("isLoggedIn");
        navigate("/");

        window.location.reload();
    };

    const isActiveClass = (paths) => {
        if (Array.isArray(paths)) {
            return paths.some(path => location.pathname.startsWith(path));
        }

        return location.pathname.startsWith(paths);
    };

    return (
        <aside className="aside is-placed-left is-expanded">
            <div className="aside-tools">
                <div>
                    <Link to={isLoggedIn ? "/dashboard" : "/"}>
                        Admin <b className="font-black">Panel</b>
                    </Link>
                </div>
            </div>
            <div className="menu is-menu-main">
                <ul className="menu-list">
                    <li className={isActiveClass('/dashboard') ? 'active' : ''}>
                        <Link to={isLoggedIn ? "/dashboard" : "/"}>
                            <span className="icon"><i className="mdi mdi-desktop-mac"></i></span>
                            <span className="menu-item-label">Dashboard</span>
                        </Link>
                    </li>
                    {["admin", "artist", "agent", "organization"].includes(role) && (
                        <li className={isActiveClass(['/artists', '/artist']) ? 'active' : ''}>
                            <Link to={isLoggedIn ? "/artists" : "/"}>
                                <span className="icon"><i className="mdi mdi-cart"></i></span>
                                <span className="menu-item-label">Artists</span>
                            </Link>
                        </li>
                    )}
                    {["admin", "agent", "organization"].includes(role) && (
                        <li className={isActiveClass(['/agents', '/agent']) ? 'active' : ''}>
                            <Link to={isLoggedIn ? "/agents" : "/"}>
                                <span className="icon"><i className="mdi mdi-apps"></i></span>
                                <span className="menu-item-label">Agents</span>
                            </Link>
                        </li>
                    )}
                    {role === "admin" && (
                        <li className={isActiveClass(['/users', '/user']) ? 'active' : ''}>
                            <Link to={isLoggedIn ? "/users" : "/"}>
                                <span className="icon"><i className="mdi mdi-account-multiple"></i></span>
                                <span className="menu-item-label">Users</span>
                            </Link>
                        </li>
                    )}
                </ul>
            </div>
        </aside>
    );
}


export default Sidebar;


